module.exports = __webpack_public_path__ + "static/media/36.ba7f92ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/36.png
// module id = 1387
// module chunks = 0